import { DatePipe } from '@angular/common';
import { AfterViewInit, Component } from '@angular/core';
import { AppService } from 'src/app/app.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements AfterViewInit {

  lastLoginDate:any="05/08/2024";
  lastLoginTime:any= "08:59";

  constructor(private datePipe:DatePipe, private appService:AppService) { }

  ngAfterViewInit(): void {
    setTimeout(() => {
    let data:any = sessionStorage.getItem('user-data');
    let userData = JSON.parse(data);
    let dateTime:any = new Date(userData?.LastLoginTime)
    this.lastLoginDate = this.appService.onDateFromTimeZone(userData?.LastLoginTime);
    this.lastLoginTime = `${dateTime.getHours()}:${dateTime.getMinutes()}:${dateTime.getSeconds()}`
    },5000);
  }

  onLeagel(type:string){
    if(type ==="terms"){
      
      window.open('https://www.dhl.com/global-en/footer/privacy-notice.html#masthead', '_blank');     
    }
    else if(type=== 'privacy' || type === 'cookie'){
      window.open('https://dsc-um-uat.dhl.com/um/doc/privacy_notice_en.html', '_blank');     
    }
  }


}
